// @ts-nocheck
import * as React from "react";

const MagnifierOutline: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
            <path
                d="m51.3 54.8 3.9 4.7c-.2.5-.1 1.1.2 1.6l13.7 18c.4.5 1 .9 1.7.9h.3c.6 0 1.1-.2 1.6-.6l3-2.5c.5-.4.8-1 .9-1.7s-.2-1.3-.6-1.8L60.9 56.5c-.4-.5-1-.6-1.6-.5l-3.8-4.5"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <circle
                cx="42"
                cy="38.5"
                r="18.5"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <path d="m55.1 59.5 4.3-3.5" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" />
        </svg>
    );
};

export default React.memo(MagnifierOutline);
